module.exports = __webpack_public_path__ + "media/img/super-venue/icons/support-87097c8b51c450124cf77f533b8df090.svg";